import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  data: [],
  loading: false,
  error: "",
};

const storeSlice = createSlice({
  name: "stores",
  initialState,
  reducers: {
    loadStoresLoading(state) {
      state.loading = true;
      state.error = "";
    },
    loadStoresSuccess(state, action) {
      state.data = action.payload;
      state.loading = false;
    },
    loadStoresError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { loadStoresLoading, loadStoresSuccess, loadStoresError } =
  storeSlice.actions;
export default storeSlice.reducer;
